import React, { Component } from 'react';
import {Route, Link} from 'react-router-dom';

import './GothicA1.scss';

class GothicA1 extends Component {
  render() {
    const {input, onChange} = this.props;

    return (
      <li>
        <Link to="/gothic_a1/detail">
          <div className="dashed-wrap gothic_a1">
            <h4 className="content-title">
              <span className="font-company">HanYang I&C Co</span>
              <span className="font-title">Gothic A1</span>
            </h4>
            <p className="font-text">{input}</p>
          </div>
        </Link>
      </li>
    );
  }
}

export default GothicA1;